import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

const TRIED = ['Rested', 'Stretched', 'Foam rolled', 'Changed your shoes', 'Random exercises from Instagram'];

export default function ProblemSection() {
  return (
    <section className="py-20 sm:py-24 px-6 bg-[#F4EFE6] text-[#0B0B0B]" data-testid="problem-section">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
          >
            <div className="text-xs uppercase tracking-widest text-[#0B0B0B]/50 mb-4 font-semibold">Sound familiar?</div>
            <h2 className="text-4xl sm:text-5xl font-bold leading-tight mb-8" style={{ fontFamily: 'Clash Display' }}>
              You've Tried Everything.
              <br />
              <span className="text-[#B7935B]">But The Pain Keeps Coming Back.</span>
            </h2>
            <ul className="space-y-3 mb-8">
              {TRIED.map((item, i) => (
                <li key={i} className="flex items-center gap-3" data-testid={`tried-item-${i}`}>
                  <X className="w-4 h-4 text-[#0B0B0B]" strokeWidth={3} />
                  <span className="text-base sm:text-lg">{item}</span>
                </li>
              ))}
            </ul>
            <p className="text-[#0B0B0B]/70">...and it feels better for a while.</p>
            <p className="font-bold text-lg mt-1">But as soon as you train or run, the pain is back.</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="rounded-2xl overflow-hidden shadow-xl"
          >
            <img src="/images/back-pain.jpg" alt="Middle-aged man holding his lower back in pain" className="w-full aspect-square object-cover" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
